module.exports = new __parcel__URL__("connected_earth_water_resources.7c53b124.png").toString();